import { memo, useCallback } from 'react'

import { Stack, Text } from '@mantine/core'
import { useTimeout } from '@mantine/hooks'
import type { MessageHandler } from '@sumsub/websdk'
import SumsubWebSdk from '@sumsub/websdk-react'

import {
  type KYCTokenOptionsType,
  useGetKycAccessToken,
  useGetKycStatus,
} from '@repo/common/queries/kyc'

const config = {}
const options = {
  adaptIframeHeight: true,
}

export const SumsubComponent = memo<KYCTokenOptionsType>(
  function SumsubComponent({ ...kyc_token_options }) {
    const {
      data: access_token,
      refetch,
      isLoading,
    } = useGetKycAccessToken(kyc_token_options)

    const { refetch: kyc_status_refetch } = useGetKycStatus()

    const { start } = useTimeout(() => void kyc_status_refetch(), 1000)

    const onRefresh = useCallback(async () => {
      const token = await refetch()
      return token.data ?? ''
    }, [refetch])

    const onMessage = useCallback(
      (
        type: Parameters<MessageHandler>[0],
        // payload: Parameters<MessageHandler>[1],
      ) => {
        if (type === 'idCheck.onApplicantStatusChanged') {
          void kyc_status_refetch()
        }
      },
      [kyc_status_refetch],
    )

    if (isLoading) return null
    if (access_token == null) {
      console.error('No access token')
      return null
    }

    if (access_token == 'faked') {
      start()

      return (
        <Stack>
          <Text>On Testnet no actually KYC/B process is performed</Text>
        </Stack>
      )
    }

    return (
      <SumsubWebSdk
        accessToken={access_token}
        expirationHandler={onRefresh}
        config={config}
        options={options}
        onMessage={onMessage}
        onError={console.error}
        /* @ts-expect-error: passing for test checking */
        kyc_token_options={kyc_token_options}
      />
    )
  },
)
